<template>
  <div v-if= "mode === 'portfolio-builder'">
    <b-tooltip
      v-bind:label="`${ screen.is_inclusionary ? 'Green flag (positive) for' : 'Red flag (negative) for' } ${ screen.is_binary ? 'all' : 'the worst' } companies associated with this metric`"
      multilined
      position="is-bottom"
      type="is-light"
      class="switch-widget"
    >
      <b-switch
        v-model="switchState"
        size="is-medium"
      >
      </b-switch>
    </b-tooltip>
  </div>
  <div v-else >
    <b-tooltip
      v-bind:label="`Add to Values Set`"
      multilined
      position="is-bottom"
      type="is-light"
      class="switch-widget"
    >
      <b-switch
        v-model="switchState"
        size="is-medium"
      >
      </b-switch>
    </b-tooltip>
  </div>
</template>
<script>


export default {
  data() {
    return {
    };
  },
  props: {
    screen: Object,
  },
  computed: {
    switchState: {
      get: function() {
        return this.screen.userPercentile === 0 ? false : true;
      },
      set: function(value) {
        if (!value) {
          this.$emit('change', 0);
          return;
        }
        // Binary metrics are inherently 0-or-100 (include all / exclude all),
        // so they don't need an admin default lookup.
        if (this.screen.is_binary) {
          this.$emit('change', 100);
          return;
        }
        // Non-binary: use the metric's user_percentile (VADIS default set in Metric Meter Admin), else 20.
        const dbPercentile = this.screen?.metric_meter_weighting?.user_percentile;
        this.$emit('change', dbPercentile != null ? dbPercentile : 20);
      },
    },
    mode: function() {
      return window.location.href.includes('portfolio-builder') ? 'portfolio-builder' : 'values-selector';
    },
  },
  methods: {},
  created: function() {

  },
  beforeUpdate: function() {
  },
  mounted: function() {

  },
};
</script>

<style lang="scss">
</style>
